import { Component, EventEmitter, Output } from '@angular/core';
import { BaseRegulatorySectionComponent } from '../../../common/base-regulatory-section/base-regulatory-section.component';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-waiver-feed-in-compensation',
  templateUrl: './waiver-feed-in-compensation.component.html',
  styleUrls: ['./waiver-feed-in-compensation.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class WaiverFeedInCompensationComponent extends BaseRegulatorySectionComponent {
  @Output() changeCommentText = new EventEmitter<string>();

  protected get sectionComment(): string {
    return this.regulatoryData.regulatory_data_sections_state?.waiver_of_feed_in_compensation_comment;
  }

  protected set sectionComment(value: string) {
    this.regulatoryData.regulatory_data_sections_state.waiver_of_feed_in_compensation_comment = value;
  }

  protected get sectionLocked(): boolean {
    return this.regulatoryData.regulatory_data_sections_state?.is_waiver_of_feed_in_compensation_locked;
  }

  protected set sectionLocked(value: boolean) {
    this.regulatoryData.regulatory_data_sections_state.is_waiver_of_feed_in_compensation_locked = value;
  }
}
